module.exports = __webpack_public_path__ + "static/media/topImg.bfa497df.png";